module.exports = {
	siteMetadata: {
		title: "Jaycee | Energy Solutions & Electrical Stamping",
		url: "https://www.jayceepower.com/",
		description: "Jaycee | Leading OEM for silent DG sets powered with TMTL/ Eicher engines",
		image: "",
	},
	plugins: [
		`gatsby-plugin-sass`,
		{
			resolve: "gatsby-plugin-google-analytics",
			options: {
				trackingId: "UA-177053754-1",
			},
		},
	]
}

// <!-- Global site tag (gtag.js) - Google Analytics -->
// <script async src="https://www.googletagmanager.com/gtag/js?id=UA-131101289-1"></script>
// <script>
//   window.dataLayer = window.dataLayer || [];
//   function gtag(){dataLayer.push(arguments);}
//   gtag('js', new Date());

//   gtag('config', 'UA-131101289-1');
// </script>



// WEBPACK FOOTER //
// ./gatsby-config.js